import { z } from 'zod';

export const PersonInspectionsRoleSchema = z.enum(['InspectionsNone','InspectionsUser','InspectionsAdmin']);

export type PersonInspectionsRoleType = `${z.infer<typeof PersonInspectionsRoleSchema>}`

export default PersonInspectionsRoleSchema;
